module.exports = __webpack_public_path__ + "static/media/complete.994a3ecb.svg";